// Norwegian profanity filter (frontend, aligned with backend behavior)
const NORWEGIAN_PROFANITY = [
  'analt', 'anus', 'blotter', 'blotting', 'blowjob', 'boobs', 'brystene', 'cum', 'cumming',
  'deepthroat', 'dickpic', 'dirtytalk', 'groomer', 'grooming', 'horekunde', 'klitoris', 'naked',
  'nude', 'nudes', 'orgasm', 'pupp', 'pupper', 'rasshøl', 'sexchat', 'sexprat', 'sexslave', 'tits',
  'tøs', 'rumpehull', 'rumpehullet', 'vagina', 'voldta', 'voldtekt', 'voldtektsmann', 'vulva',
  'asshole', 'bastard', 'bitch', 'cunt', 'dick', 'drittsekk', 'drittunge', 'faen', 'faggot',
  'fakkings', 'fanken', 'fitte', 'fittehøl', 'fittetiss', 'forbanna', 'forbannet', 'fuck', 'fucker',
  'fucking', 'føkk', 'føkka', 'helvete', 'helvetet', 'hestkuk', 'homo', 'hore', 'idiot', 'jævel',
  'jævelsk', 'jævla', 'jævlig', 'knulle', 'kuk', 'kukene', 'kuker', 'kuse', 'lesbe', 'ludder',
  'mongo', 'morraknuller', 'morrapuler', 'motherfucker', 'nigger', 'pakkis', 'pikk', 'pokker',
  'pule', 'pussy', 'rass', 'retard', 'runk', 'ræva', 'ræven', 'rævva', 'satan', 'shit', 'sinnsykt',
  'skit', 'skitt', 'slut', 'sotrør', 'ståpikk', 'ståpikkene', 'sæd', 'svartinger',
];

function normalizeText(text: string): string {
  return text
    .toLowerCase()
    // Remove obfuscation separators between letters, but keep normal word spacing.
    .replace(/([a-zæøå])[._-]+(?=[a-zæøå])/gi, '$1')
    // Collapse spaced-letter obfuscation (e.g. "f a e n" -> "faen").
    .replace(/\b((?:[a-zæøå]\s+){2,}[a-zæøå])\b/gi, (match) => match.replace(/\s+/g, ''))
    .replace(/4/g, 'a')
    .replace(/3/g, 'e')
    .replace(/1/g, 'i')
    .replace(/0/g, 'o')
    .replace(/5/g, 's')
    .replace(/7/g, 't')
    .replace(/@/g, 'a')
    .replace(/\$/g, 's')
    .replace(/(.)\1{2,}/g, '$1');
}

export function containsProfanity(text: string): boolean {
  if (!text) return false;
  const normalizedText = normalizeText(text);
  return NORWEGIAN_PROFANITY.some((word) => {
    const normalizedWord = normalizeText(word);
    const regex = new RegExp(`\\b${normalizedWord}\\b`, 'i');
    return regex.test(normalizedText);
  });
}

export function detectProfanityWords(text: string): string[] {
  if (!text) return [];
  const normalizedText = normalizeText(text);
  const detectedWords: string[] = [];
  NORWEGIAN_PROFANITY.forEach((word) => {
    const normalizedWord = normalizeText(word);
    const regex = new RegExp(`\\b${normalizedWord}\\b`, 'i');
    if (regex.test(normalizedText)) detectedWords.push(word);
  });
  return detectedWords;
}

export function validateText(text: string, fieldName: string): { isValid: boolean; error?: string } {
  if (!text) return { isValid: true };
  const detectedWords = detectProfanityWords(text);
  if (detectedWords.length > 0) {
    return {
      isValid: false,
      error: `${fieldName} inneholder upassende språk. Vennligst bruk et profesjonelt språk.`,
    };
  }
  return { isValid: true };
}

export function filterProfanity(text: string): string {
  if (!text) return text;
  let filtered = text;
  NORWEGIAN_PROFANITY.forEach((word) => {
    const regex = new RegExp(`\\b${word}\\b`, 'gi');
    filtered = filtered.replace(regex, '*'.repeat(word.length));
  });
  return filtered;
}
